module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnumber"
  }, [_c('a', {
    attrs: {
      "id": "h6"
    }
  }, [_vm._v("Route 1")])]), _c('a', {
    attrs: {
      "id": "h6"
    }
  }, [_c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("Bois-Grenier")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A circular route beginning at: Le Bridoux")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Coordinates: 50°38 05.43” N – 2°53 09.40” E")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Distance: 5.7km/3.5 miles")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Suitable for:")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images",
      "src": "images/man.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images",
      "src": "images/cycle.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grade: Easy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maps: IGN Série Bleue 2404 E – Armentières")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("General description and context:")]), _vm._v(" The main focus of this route is the action that took place here on 25 September 1915. Three battalions of 25 Infantry Brigade – 2/Rifle Brigade, 2/Royal Berkshires and 2/Lincolns, with 1/Royal Irish Rifles and 1/8 Middlesex in reserve, assaulted the German front line between "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Corner Fort")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Bridoux Fort")]), _vm._v(", a frontage of just over 1,000m. The action was one of three designed to draw attention away from the Battle of Loos which opened a few hours later on the same day. Apart from the preliminary artillery barrage, the attack began with a largely ineffectual mine explosion on both flanks. The Corner Fort position was quickly taken by 2/Rifle Brigade, whilst the Bridoux Fort strongpoint fell to 2/Lincolns. However, in the centre at "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Angle Point")]), _vm._v(", the Royal Berks, despite taking a point known as the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Lozenge")]), _vm._v(", were unable to make progress against continuous machine-gun fire directed from this small salient which jutted out into no-man’s-land. This strongpoint not only held up the Berkshires but prevented any further attempts to cross no-man’s-land by the British and ultimately forced the two flank attacks to withdraw in the face of determined German counter-attacks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions to start:")]), _vm._v(" Le Bridoux is a small village west of the D62 which runs southeast from Bois-Grenier to Radinghem-en-Weppes. Approaching from Bois-Grenier on the D22 take the second turning on the right after you pass White City Cemetery. There is a small memorial ‘Garden of Peace’ "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images",
      "src": "images/f1.jpg"
    }
  }), _vm._v(" situated in front of the farm buildings. Unveiled in 2005 by the Liverpool Scottish Museum Trust, it commemorates the officers and men of 2/10 King’s Liverpool Regiment who took part in the company strength daylight trench raid known as ‘Dicky’s Dash’ on 29 June 1917. Led by "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Captain Alan Piele Dickinson MC")]), _vm._v(", the 161 men of the ‘Liverpool Scottish’ attacked from the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Bridoux Road Salient")]), _vm._v(" ‘to destroy as many of the enemy as possible’ and established a foothold in the German trenches. It was a costly exercise – 15 killed, 50 wounded and 35 missing – and many of the casualties rest in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Erquinghem Churchyard Extension Cemetery")]), _vm._v(", 4km northwest of Bois-Grenier. Basil Rathbone, the actor whom many still see as the definitive Sherlock Holmes, served as an officer in the 2/10 Liverpool Scottish in this sector in 1918, earning the Military Cross (MC) in September that year for his resourcefulness during daylight patrols in no-man’s-land. Intriguingly, Rathbone’s medal card gives his address as 527 North Camden Drive, Beverly Hills, California.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132387a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/38_chapter01.vue
// module id = 171
// module chunks = 0